export default __webpack_public_path__ + "static/media/indexing-pages-1.b4825a38.svg";